@if (svc.isOpen()) {
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-talos-ink/55 z-[600] flex items-center justify-center p-4">

    <!-- Card -->
    <div class="bg-[var(--talos-bg)] rounded w-full max-w-sm overflow-hidden" style="border:1px solid rgb(var(--talos-ink-rgb) / 0.1)">

      <!-- Icon + header -->
      <div class="flex flex-col items-center px-6 pt-7 pb-4 text-center">
        <div class="w-14 h-14 rounded flex items-center justify-center mb-4" style="background:rgb(var(--talos-ink-rgb) / 0.06)">
          <lucide-icon [img]="AlertTriangleIcon" [size]="28" color="var(--talos-ink)" />
        </div>
        <h2 class="text-lg font-bold text-talos-ink">
          {{ svc.options().title ?? 'Confirm Delete' }}
        </h2>
        @if (svc.options().itemName) {
          <p class="text-sm mt-1" style="color:rgb(var(--talos-ink-rgb) / 0.5)">
            {{ svc.options().message }}
            <span class="font-semibold text-talos-ink">"{{ svc.options().itemName }}"</span>?
          </p>
        } @else {
          <p class="text-sm mt-1" style="color:rgb(var(--talos-ink-rgb) / 0.5)">{{ svc.options().message }}</p>
        }
        <p class="text-xs mt-2" style="color:rgb(var(--talos-ink-rgb) / 0.4)">This action cannot be undone.</p>
      </div>

      <div style="border-top:1px solid rgb(var(--talos-ink-rgb) / 0.08)"></div>

      <!-- Actions -->
      <div class="flex gap-3 px-6 py-4">
        <app-button
          class="flex-1"
          label="{{ svc.options().cancelLabel ?? 'Cancel' }}"
          variant="cancel"
          [fullWidth]="true"
          tooltip="Go back"
          (clicked)="svc.resolve(false)" />
        <app-button
          class="flex-1"
          label="{{ svc.options().confirmLabel ?? 'Delete' }}"
          variant="danger"
          [fullWidth]="true"
          tooltip="Confirm delete"
          (clicked)="svc.resolve(true)" />
      </div>

    </div>
  </div>
}
